<script lang="ts" setup>
import ApiService from "@/shared/api";
import { onBeforeMount, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import {
  TirPmNotificationEventBus,
  TirPmNotificationGroup,
  TirPmNotificationModel,
} from "tir-components";
import LoadingFilesWidget from "widgets/loading-files-widget";
import NotificationConnection from "widgets/notification-connection";
import NotificationConnectionVariantEnum from "./enums/NotificationConnectionVariantEnum";

const api = new ApiService();
const router = useRouter();

/**Состояние коннекта с интернетом */
const stateConnect = ref<NotificationConnectionVariantEnum>();

/**
 * Выбросить юзера на авторизацию если его статус изменился
 */
onMounted(() => {
  api.Main.PerformersSaveService.SessionLogoutEventEvent.on(() => {
    console.log("LOGOUT EVENT");
    router.push("/login");
  });
  toggleSubscribe(true);
  document.addEventListener("test-manager-notification", testmanager);
});

/**Подписки */
const toggleSubscribe = (isSubscribe?: boolean) => {
  const windowFunc: keyof Window = isSubscribe
    ? "addEventListener"
    : "removeEventListener";

  window[windowFunc]("offline", () =>
    updateConnectionStatus(NotificationConnectionVariantEnum.Disconnected)
  );
  window[windowFunc]("online", () =>
    updateConnectionStatus(NotificationConnectionVariantEnum.Connected)
  );
  window[windowFunc]("focus", () => {
    setTimeout(() => {
      if (stateConnect.value === NotificationConnectionVariantEnum.Connected) {
        stateConnect.value = null;
      }
    }, 2000);
  });
};
onBeforeUnmount(() => {
  document.removeEventListener("test-manager-notification", testmanager);
});

function testmanager(event) {
  TirPmNotificationEventBus.emit("add", event.detail);
}
/**Обновить состояние соединения  */
const updateConnectionStatus = (state: NotificationConnectionVariantEnum) => {
  stateConnect.value = state;

  setTimeout(() => {
    if (stateConnect.value === NotificationConnectionVariantEnum.Disconnected) {
      stateConnect.value = NotificationConnectionVariantEnum.Reconnected;
    }
  }, 20000);
};
/**Закрыть уведомление */
const closeNotification = () => {
  stateConnect.value = null;
};
</script>
<template>
  <RouterView />
  <LoadingFilesWidget />
  <TirPmNotificationGroup
    group="general"
    position="top-right"
    :zIndex="20000"
  />
  <NotificationConnection
    :variant="stateConnect"
    @closeNotification="closeNotification"
    @reconnect="
      updateConnectionStatus(NotificationConnectionVariantEnum.Disconnected)
    "
  />
</template>

<style lang="scss">
#app {
  overflow: hidden;
}
</style>
